import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { RADAR_QUERY_KEY } from "@/lib/radar";

export const SAVED_MATCHES_KEY = ["saved-matches"];

export const savedMatchesApi = {
  list: () => api.get("/saved-matches").then((r) => r.data),
  save: (user_id) => api.post("/saved-matches", { user_id }).then((r) => r.data),
  unsave: (user_id) => api.delete(`/saved-matches/${user_id}`).then((r) => r.data),
};

export function useSavedMatches() {
  return useQuery({
    queryKey: SAVED_MATCHES_KEY,
    queryFn: savedMatchesApi.list,
    staleTime: 30_000,
  });
}

export function useSaveMatch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: savedMatchesApi.save,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SAVED_MATCHES_KEY });
      qc.invalidateQueries({ queryKey: RADAR_QUERY_KEY });
    },
  });
}

export function useUnsaveMatch() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: savedMatchesApi.unsave,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SAVED_MATCHES_KEY });
      qc.invalidateQueries({ queryKey: RADAR_QUERY_KEY });
    },
  });
}
